/**
 * The line that says a page is for websites built on HubSpot, with HubSpot's
 * own mark beside it.
 *
 * One component rather than the same three elements typed on each page, so
 * the mark is the same size and the same distance from its words everywhere
 * it appears. The mark is decorative: the words next to it already say what
 * it means, so it is hidden from screen readers rather than announced twice.
 */
import type { ReactNode } from 'react'
import HubSpotIcon from '@/components/icons/HubSpotIcon'
import { cn } from '@/utils/cn'
/* The component carries its own sizing rather than trusting each page that
   uses it to have loaded market.css already. */
import '@/design-system/market.css'

export default function HubSpotEyebrow({
  children,
  className,
  style,
}: {
  children: ReactNode
  className?: string
  style?: React.CSSProperties
}) {
  return (
    <p className={cn('ds-small ds-faint ds-eyebrow--mark', className)} style={style}>
      <span aria-hidden="true" style={{ display: 'inline-flex' }}>
        <HubSpotIcon className="ds-hsmark" />
      </span>
      {children}
    </p>
  )
}
